import type { Quill } from "quill";

type Op = { insert: unknown; attributes?: { color?: unknown } };

const TOKEN_PATTERN = /<([^<>\n]+)>/g;

/*
 * Paints the known `<Variable>` tokens blue, skipping every character that
 * already has a colour, so a colour the author chose survives reopening.
 * Black is never stored, so a token typed before the list was known reads as
 * uncoloured and is still painted.
 */
function highlightVariableTokens(quill: Quill, known: Set<string>) {
  // An embed takes one index in Quill; one placeholder character keeps the
  // match offsets equal to document indices.
  const text = (quill.getContents().ops as Op[])
    .map((op) => (typeof op.insert === "string" ? op.insert : "￼"))
    .join("");

  Array.from(text.matchAll(TOKEN_PATTERN)).forEach((match) => {
    const { 0: token, 1: name, index: start = 0 } = match;
    if (!known.has(name)) return;

    let index = start;
    (quill.getContents(index, token.length).ops as Op[]).forEach((op) => {
      const length = typeof op.insert === "string" ? op.insert.length : 1;
      if (!op.attributes?.color) {
        quill.formatText(index, length, "color", "#2979FF", "silent");
      }
      index += length;
    });
  });
}

export default highlightVariableTokens;
